/* src/app/shared/ui/components/suggestion-card/suggestion-card.component.scss */
:host {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.container {
  display: flex;
  flex-direction: column;
  direction: ltr;
  max-height: inherit;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}
.container__card-wrapper {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border-radius: 8px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #fafbff;
  box-shadow: 0 2px 5px -2px rgba(109, 118, 176, 0.2);
}
.container__card-wrapper--last {
  margin-bottom: 0;
}
.container__card-wrapper--selected {
  background-color: #eae7e7;
}
.container__content-wrapper {
  display: flex;
  flex-direction: row;
  flex: 1;
  padding: 8px;
  min-width: 0;
}
.container__info-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
  min-width: 0;
}
.container__info {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
}
.container__subtitle-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  height: 16px;
  -webkit-user-select: none;
  user-select: none;
}
.container__subtitle-text-wrapper,
.container__total-time-wrapper {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}
.container__trash-icon {
  cursor: pointer;
  height: 16px;
  width: 16px;
  transition: opacity 0.12s linear;
}
.container__trash-icon:hover {
  opacity: 0.7;
}
.container__more-icon {
  cursor: pointer;
  height: 14px;
  width: 4px;
  transition: opacity 0.12s linear;
}
.container__more-icon:hover {
  opacity: 0.7;
}
.container__title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
  line-height: 1.4em;
  max-height: 2.8em;
  max-width: 325px;
  white-space: pre-line;
  word-break: break-all;
}
.container__title--bold {
  font-weight: 600;
}
.container__subtitle {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  direction: rtl;
  text-overflow: ellipsis;
  max-width: 320px;
}
.container__subtitle--bold {
  font-weight: 600;
}
.container__subtitle-prefix {
  font-size: 14px;
  font-weight: 600;
}
.container__total-time {
  font-size: 14px;
  color: var(--Gray-400, #41444e);
  font-weight: 400;
  -webkit-user-select: none;
  user-select: none;
  white-space: nowrap;
}
.container__total-time-prefix {
  font-size: 16px;
  font-weight: 500;
  color: var(--Gray-500-text, #182039);
}
.container__platform-icon-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-inline-start: 8px;
}
.container__platform-icon {
  height: 30px;
  width: 30px;
}
.container__side-label-wrapper {
  display: flex;
  width: 25px;
  border-start-end-radius: 8px;
  border-end-end-radius: 8px;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: row;
  background-color: #97b9ee;
}
.container__side-label-wrapper--morning {
  background-color: #90baf0;
}
.container__side-label-wrapper--midday {
  background-color: #5a97e7;
}
.container__side-label-wrapper--afternoon {
  background-color: #2b5fb6;
}
.container__side-label-wrapper--evening {
  background-color: #224c93;
}
.container__side-label-wrapper--night {
  background-color: #1c3866;
}
.container__side-label-wrapper--no-time {
  background-color: #d3dce8;
}
.container__side-label {
  writing-mode: vertical-rl;
  color: white;
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-height: 50px;
  padding-inline: 4px;
}
:host-context([dir=ltr]) .container {
  direction: rtl;
}
:host-context([dir=ltr]) .container__tile {
  direction: ltr;
}
:host-context([dir=ltr]) .container__subtitle {
  direction: ltr;
}
:host-context([dir=ltr]) .container__side-label {
  transform: rotate(180deg);
}
/*# sourceMappingURL=suggestion-card.component.css.map */
